exports.f = require('./_wks');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.4.1@core-js/library/modules/_wks-ext.js
 ** module id = 110
 ** module chunks = 0
 **/